// extracted by mini-css-extract-plugin
module.exports = {"root":"Mission_root__2_RxL","title":"Mission_title__3Kqnb","copy":"Mission_copy__2Jmgv"};